/** Sınıf adlarını birleştirir (shadcn `cn` yardımcıına benzer, bağımsız). */
export function cn(
  ...classes: Array<string | false | null | undefined>
): string {
  return classes.filter(Boolean).join(" ");
}